import React from 'react';
import type { StyleProp, ViewStyle } from 'react-native';
import type { CallStream } from '../calls/types';

type Props = {
  stream: CallStream | null;
  style?: StyleProp<ViewStyle>;
  mirror?: boolean;
  testID?: string;
};

/**
 * Çağrı görüntüsü — **web ve varsayılan** (9.4.14).
 *
 * Web'de görüntü henüz çizilmiyor ve bu bilinçli: tarayıcıda akış bir `<video>`
 * elementine `srcObject` ile bağlanır, o da React Native'in JSX'inde olmayan bir
 * DOM elementidir. Web'in görüntülü aramaya girmesi kendi işi; sesli arama
 * web'de çalışmaya devam eder.
 *
 * Burada `null` dönmek, yanlış bir şey çizmekten iyidir: boş bir kutu kullanıcıya
 * "görüntü var ama gelmiyor" der, oysa web'de hiç istenmemiştir.
 */
export default function CallVideo(_props: Props) {
  return null;
}
